import React from 'react';

function Results() {
  const results = [
    {
      title: 'Launch Success',
      description: 'Migrated contact centers for global enterprises, maintaining 99.95% uptime throughout the journey.',
      icon: '🚀', // Unicode rocket emoji as a placeholder; replace with SVG or FontAwesome
    },
    {
      title: 'Cost Efficiency',
      description: 'Cut operational costs by 20-30% with AWS-driven efficiency',
      icon: '💰⬇️', // Unicode money bag and down arrow; replace with custom icon
    },
    {
      title: 'Customer Satisfaction',
      description: 'Boosted customer satisfaction scores across industries like Travel and Hospitality.',
      icon: '😊⬆️', // Unicode happy face and up arrow; replace with custom icon
    },
  ];

  return (
    <section id="results" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-blue-900">Our Results</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {results.map((result, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition text-center"
            >
              <div className="text-4xl mb-4 text-blue-900">{result.icon}</div> {/* Icon display */}
              <h3 className="text-xl font-semibold text-blue-900 mb-2">{result.title}</h3>
              <p className="text-gray-700">{result.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Results;